import React, { Component } from "react";
import { Wrapper, Card, CardBody, Copy } from "app/NativeComponents/common";
import { MenuItem } from "app/NativeComponents/snippets";

import UploadButton from "./UploadButton";

class ExportOptions extends Component {
  render() {
    if (
      this.props.device == "desktop" &&
      (this.props.user.team_clearance_level > 1 ||
        this.props.user.can_export_data == 1)
    ) {
      return (
        <Wrapper>
          <Card>
            <UploadButton {...this.props} />
          </Card>
          <CardBody>
            <Copy>
              Looking to export your leads? Export your leads by selecting them
              in the "Leads View" and press "Export Leads."
            </Copy>
          </CardBody>
        </Wrapper>
      );
    } else if (
      this.props.device == "mobile" &&
      (this.props.user.team_clearance_level > 1 ||
        this.props.user.can_export_data == 1)
    ) {
      return (
        <Card>
          <MenuItem
            to=""
            onPress={() => {
              this.props.setModal({
                title: "This feature is only available in desktop version",
                description:
                  "Please visit: DealMachine.com on your desktop computer",
                icon: "desktop-mac",
                submit: "Dismiss",
                onPress: () => {},
                cancel: "",
                onCancel: () => {}
              });
              this.props.toggleModal({ show: true, type: "normal" });
            }}
            title="Export Leads"
            text={"Export leads to a .csv file"}
          />
        </Card>
      );
    }

    return <Wrapper />;
  }
}

export default ExportOptions;
